import React from 'react';
import FormikForm from './formik';

const Form = (props) => {
  return <FormikForm {...props} />;
};

export default Form;
